<div class="location-scope-picker">
    <mat-form-field appearance="outline" class="location-scope-picker__select">
        <mat-label>{{ label }}</mat-label>
        <mat-select
            multiple
            [value]="selectedIds"
            [disabled]="disabled"
            [required]="required"
            [placeholder]="placeholder"
            (selectionChange)="selectedIdsChanged($event.value)">
            <mat-option *ngFor="let node of nodes" [value]="node.id">
                <span class="location-scope-picker__option" [style.padding-left.px]="optionIndent(node)">
                    <small>{{ typeLabel(node) }}</small>
                    <span>{{ node.name }}</span>
                </span>
            </mat-option>
        </mat-select>
        <mat-progress-spinner *ngIf="loading" matSuffix diameter="18" mode="indeterminate"></mat-progress-spinner>
    </mat-form-field>

    <div class="location-scope-picker__rows" *ngIf="selections.length">
        <div class="location-scope-picker__row" *ngFor="let selection of selections">
            <div class="location-scope-picker__copy">
                <strong>{{ selectedNode(selection)?.name || selection.nodeId }}</strong>
                <small>{{ selectedNode(selection)?.displayPath }}</small>
            </div>
            <mat-checkbox
                [checked]="selection.includeDescendants"
                [disabled]="disabled"
                (change)="includeDescendantsChanged(selection.nodeId, $event.checked)">
                Include descendants
            </mat-checkbox>
        </div>
    </div>
</div>
